import type { ReactNode } from "react";
import { Wrench, Clock } from "lucide-react";
import { StepInfoRow } from "../../StepInfoRow";
import { getString, getNumber } from "../helpers";
import type { SummaryTranslator } from "../types";

export function getMcpToolCallSummary(config: Record<string, unknown>, t: SummaryTranslator): ReactNode[] {
  const items: ReactNode[] = [];

  const toolId = getString(config.tool_id);
  const toolDisplay = getString(config.tool_display);
  const timeoutSeconds = getNumber(config.timeout_seconds);
  const maxRetries = getNumber(config.max_retries);

  if (toolId) {
    items.push(
      <StepInfoRow
        key="tool"
        icon={<Wrench className="size-3.5" />}
        label={t("summaries.mcp_tool_call.label_tool")}
        value={toolDisplay || t("summaries.shared.unknown_reference")}
      />
    );
  }

  if (timeoutSeconds !== undefined) {
    items.push(
      <StepInfoRow
        key="timeout"
        icon={<Clock className="size-3.5" />}
        label={t("summaries.mcp_tool_call.label_timeout")}
        value={t("summaries.mcp_tool_call.timeout_seconds", { seconds: timeoutSeconds })}
        mono
      />
    );
  }

  if (maxRetries !== undefined && maxRetries > 0) {
    items.push(
      <StepInfoRow
        key="retries"
        icon={<Wrench className="size-3.5" />}
        label={t("summaries.mcp_tool_call.label_retries")}
        value={t("summaries.mcp_tool_call.retries_value", { count: maxRetries })}
      />
    );
  }

  return items;
}
